import { ApiDimension } from "@incendium/api";
import { createContext, ReactNode, useContext, useMemo, useState } from "react";

type CustomerRetentionCohortContextValue = {
  closedCohort: boolean;
  setClosedCohort: (closed: boolean) => void;
  dateDimension: ApiDimension;
};

const CustomerRetentionCohortContext =
  createContext<CustomerRetentionCohortContextValue | null>(null);

export function CustomerRetentionCohortProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [closedCohort, setClosedCohort] = useState(false);

  const dateDimension = closedCohort
    ? ApiDimension.DIMENSION_FIRST_SALE_DATE
    : ApiDimension.DIMENSION_SESSION_START_BY_DAY;

  const value = useMemo(
    () => ({ closedCohort, setClosedCohort, dateDimension }),
    [closedCohort, dateDimension],
  );

  return (
    <CustomerRetentionCohortContext.Provider value={value}>
      {children}
    </CustomerRetentionCohortContext.Provider>
  );
}

export function useCustomerRetentionCohort() {
  const context = useContext(CustomerRetentionCohortContext);
  if (!context) {
    throw new Error(
      "useCustomerRetentionCohort must be used within CustomerRetentionCohortProvider",
    );
  }
  return context;
}
